import { Link } from 'rebass'
import styled from 'styled-components'

const UprightLink = styled(Link)`
  display: inline-block;
  text-transform: uppercase;
  font-weight: normal;
  letter-spacing: 1.43px;
  text-decoration: none;
  ${props =>
    props.underlined &&
    `
    box-shadow: 0 4px 0 0 ${props.theme.colors.white}, 0 6px 0 0 ${
      props.theme.colors.black
    };
  `}

  &:hover {
    opacity: 0.4;
  }
`

export default UprightLink
